// src/app/rootReducer.js
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice'; 
import themeReducer from  '../features/theme/themeSlice';
import layoutReducer from "../features/layout/layoutSlice";
import classSectionReducer from "../features/classSection/classSectionSlice";
import classPeriodsReducer from "../features/classPeriod/classPeriodsSlice";
import getAllClassPeriodTeacherscheduleReducer from "../features/classPeriodTeacherschedule/classPeriodTeacherscheduleSlice" 
import getAllClassSubjectMappingReducer from  "../features/classSubject/classSubjectMappingSlice"
import getAllClassWithSectionsDetailsReducer from "../features/classWithSeSSubDetails/classWithSectionDetailsListSlice"
import getAllClasswithStrSubsSecReducer from "../features/classWithStreamSubStreamSection/classWithStreamSubStreamSectionListSlice"
import getAllSubjectBasedTeachersReducer from '../features/subjectBasedTeachers/subjectBasedTeachersSlice'
import classReducer from "../features/class/classSlice";
import assignedFeeStructure from "../features/assignFeetoClass/assignFeesStructureToClassSlice";
import schoolProfileReducer from "../features/schoolProfile/schoolProfileSlice";
import academicYearReducer from '../features/academicYear/academicYearSlice';
import menuReducer from '../features/SidebarMenu/menuSlice';
import staffReducer from '../features/Staff/staffSlice';
import notificationReducer from '../features/notifications/notificationSlice';
const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  layout: layoutReducer,
  classSection: classSectionReducer,
  classPeriods: classPeriodsReducer,
  classWithSectionsDetails : getAllClassWithSectionsDetailsReducer,
  allClassPeriodTeacherscheduleList: getAllClassPeriodTeacherscheduleReducer,
  class: classReducer,
  allClasswithStrSubsSeclist: getAllClasswithStrSubsSecReducer,
  classSubjectMappingList : getAllClassSubjectMappingReducer,
  subjectBasedTeachers : getAllSubjectBasedTeachersReducer,
  assignFeeStructureToClass : assignedFeeStructure,
  schoolProfile: schoolProfileReducer,
  academicYear: academicYearReducer,
  menu: menuReducer,
  staff: staffReducer,
  notification: notificationReducer,
  // Add more feature reducers here
});

export default rootReducer;
